/** Home card art (the art carries the meaning; most players do not read yet). */
export function SquishCardArt() {
  const blobs = [
    { x: 118, y: 72, r: 34, c: '#ffd60a' },
    { x: 134, y: 112, r: 26, c: '#1cc4ff' },
    { x: 104, y: 128, r: 18, c: '#ff3fa4' },
    { x: 146, y: 84, r: 16, c: '#ff3fa4' },
  ]
  return (
    <svg viewBox="0 0 320 200" className="absolute inset-0 h-full w-full" preserveAspectRatio="xMidYMid slice">
      <rect width="320" height="200" fill="#d8cdea" />
      <rect x="22" y="16" width="276" height="168" rx="6" fill="#fbf7ee" />
      <line x1="160" y1="16" x2="160" y2="184" stroke="#ebe3d3" strokeWidth="3" />
      <g style={{ mixBlendMode: 'multiply' }}>
        {blobs.map((b, i) => (
          <g key={i}>
            <circle cx={b.x} cy={b.y} r={b.r} fill={b.c} opacity="0.75" />
            <circle cx={320 - b.x} cy={b.y} r={b.r} fill={b.c} opacity="0.75" />
          </g>
        ))}
      </g>
      {/* googly eyes on the body */}
      <circle cx="150" cy="58" r="9" fill="#ffffff" stroke="#1d2b36" strokeWidth="2" />
      <circle cx="170" cy="58" r="9" fill="#ffffff" stroke="#1d2b36" strokeWidth="2" />
      <circle cx="152" cy="61" r="4" fill="#1d2b36" />
      <circle cx="172" cy="61" r="4" fill="#1d2b36" />
    </svg>
  )
}
